import type { LaneRallyBonusEvent } from '../../../../shared/laneRallyRules';
import { laneCenters } from './laneLayout';

/** Sorular arası yol kesimindeki altın/engel. `at` kesim başından metre, `x` yol genişliğine göre normalize. */
export type RoadObject = { kind: LaneRallyBonusEvent; at: number; lane: number; x: number; takenAt: number | null };

export const roadFieldRules = {
  /** Altınlı yolun uzunluğu (m): 95 km/sa'te 5 sn. Geri bildirimin ortasında başlar; bitince yeni soru açılır. */
  stretchDistance: 132,
  /** Aracın yakalama genişliği: şerit genişliğinin bu oranı kadar yatay yakınlık. */
  catchLaneRatio: 0.55,
} as const;

/**
 * Kesim içindeki sıra: üç altın ve iki engel. İlk nesne, şerit sayısı değişiminde aracın yeni şeride kayması (≈ 7 m)
 * bittikten sonra gelir; sonuncusu yeni soru açılmadan geçilir, soru açıkken yol boştur.
 */
const SPAWNS: readonly { kind: LaneRallyBonusEvent; at: number }[] = [
  { kind: 'coin', at: 22 },
  { kind: 'obstacle', at: 44 },
  { kind: 'coin', at: 66 },
  { kind: 'obstacle', at: 88 },
  { kind: 'coin', at: 110 },
];

/** Kesim numarası ve şerit sayısına göre deterministik dizilim; her öğrencide aynı soru arasında aynı düzen. */
export function createRoadField(stretchIndex: number, laneCount: number): RoadObject[] {
  const centers = laneCenters(laneCount);
  let previous = -1;
  return SPAWNS.map((spawn, j) => {
    let lane = (stretchIndex * 5 + j * 3 + (spawn.kind === 'obstacle' ? 1 : 0)) % laneCount;
    // Engel, hemen önceki altının şeridine konmaz: altını alan öğrenci doğrudan engele sürülmez.
    if (spawn.kind === 'obstacle' && lane === previous) lane = (lane + 1) % laneCount;
    previous = lane;
    return { kind: spawn.kind, at: spawn.at, lane, x: centers[lane], takenAt: null };
  });
}

/**
 * Aracın ön ucunun geçtiği nesneleri olay olarak döndürür. Geçiş (önceki < konum ≤ şimdiki) temellidir;
 * bu yüzden adım büyüklüğü nesneyi atlatamaz.
 */
export function crossRoadField(objects: RoadObject[], fromAt: number, toAt: number, carX: number, laneCount: number, clock: number): LaneRallyBonusEvent[] {
  const events: LaneRallyBonusEvent[] = [];
  const reach = roadFieldRules.catchLaneRatio / laneCount;
  for (const object of objects) {
    if (object.takenAt !== null || object.at <= fromAt || object.at > toAt) continue;
    if (Math.abs(object.x - carX) <= reach) { object.takenAt = clock; events.push(object.kind); }
  }
  return events;
}
